module.exports = require('./helpers/bundle-url').getBundleURL('h1yBP') + "logo-dark.eefe0b7f.svg";